<template>
  <div>
    <!-- Company Logo -->
    <company-logo />

    <!-- Header -->
    <list-header title="Already have an account?" />

    <!-- Content -->
    <div class="p-3 text-start">
      <div>
        Looks like there’s already an account that has the same contact
        information:
      </div>
      <div class="my-4 scss-bold">
        <div class="d-flex flex-row">
          <div class="w-25 text-start ms-5">Name</div>
          <div class="w-50 text-start ms-5">
            {{
              `${duplicateCustomerTemporary.firstName} ${duplicateCustomerTemporary.lastName}`
            }}
          </div>
        </div>
      </div>
      <div class="my-4 scss-bold">
        <div class="d-flex flex-row">
          <div class="w-25 text-start ms-5">Mobile</div>
          <div class="w-50 text-start ms-5">
            {{ phone }}
          </div>
        </div>
      </div>
      <div class="my-4 scss-bold">
        <div class="d-flex flex-row">
          <div class="w-25 text-start ms-5">Email</div>
          <div class="w-50 text-start ms-5">
            {{ email }}
          </div>
        </div>
      </div>

      <div>
        We'll send you an email for verification to claim this profile. If you
        think this user profile does not belong to you, kindly report it to the
        store.
      </div>
    </div>
    <!-- Header -->
    <list-header title="Email Information" />
    <div class="p-3 text-start">
      <div>We will be sending the OTP to the following email.</div>
      <div class="my-4 scss-bold">
        <div class="d-flex flex-row">
          <div class="w-25 text-start ms-5">Email</div>
          <div class="w-50 text-start ms-5">
            {{ email }}
          </div>
        </div>
      </div>
      <div>Do you like to update your email to receive OTP?</div>
    </div>
    <!-- Reset Passowrd Button -->
    <div class="">
      <div class="d-flex flex-row">
        <div class="w-50">
          <default-button title="Yes" @click="goToUpdateEmail" />
        </div>
        <div class="w-50">
          <default-button
            title="No"
            cssClass="scss-button-red"
            @click="goToOtp"
          />
        </div>
      </div>

      <div class="mb-3 mt-2">
        <span
          class="scss-click-effect scss-text-blue scss-clickable"
          @click="goToLogin"
          >Back to login</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ListHeader from "../../../components/ListHeader.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import CompanyLogo from "@/components/CompanyLogo.vue";

export default {
  name: "AccountExists",
  components: { ListHeader, DefaultButton, CompanyLogo },
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
    goToOtp() {
      this.$router.push("/signup/otp");
    },
    goToUpdateEmail() {
      this.$router.push("/signup/update-email");
    },
  },
  computed: {
    email() {
      const email = this.duplicateCustomerTemporary.customerDetail?.email || '';
      if (email && email !== '') {
        const emailPart = email.split("@");
        const emailUsername = emailPart[0];
        const emailDomainName = emailPart[1];

        return `${emailUsername.slice(0, 1)}****@${emailDomainName.charAt(
            0
          )}****${emailDomainName.slice(emailDomainName.length - 4)}`
      }

      return '';
    },
    phone() {
      const phoneMobile = this.duplicateCustomerTemporary.phoneMobile || '';

      if (phoneMobile && phoneMobile !== '') {
        return `****${phoneMobile.slice(
          phoneMobile.length - 4
        )}`;
      }

      return '';
    },
    ...mapGetters(["duplicateCustomerTemporary"]),
  },
};
</script>
